export default __webpack_public_path__ + "static/media/Harness of Vehement Thunder.e9aeedf8.jpg";